import { Swiper, Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

const $footer = document.querySelector('.housing-detail-footer')

const fn = {
    init: () => {
        const $slider = $footer.querySelector('.swiper-container')

        new Swiper($slider, {
            slidesPerView: 'auto',
            loop: true,
            pagination: {
                el: $footer.querySelector('.slider-pagination'),
                clickable: true,
            },
            navigation: {
                prevEl: $footer.querySelector('.slider-prev'),
                nextEl: $footer.querySelector('.slider-next'),
            },
        })
    },
}

export default {
    can: () => $footer,
    run: fn.init,
}
